import React, {Component}               from "react";
import {ImageBackground, Text, View}    from "react-native";
import {connect}                        from "react-redux";
import Modal                            from "./Modal";
import Button                           from "../Button";
import SwipeGesture                     from "../SwipeGesture";
import * as Actions                     from "../../constants/Actions";
import styles                           from "../../styles/Styles";

class ModalPoints extends Component {
    onSwipePerformed = (action) => {
        switch(action){
            case "left":{
                this.props.selectPlayer(0);
                break;
            }
            case "right":{
                if (this.props.players.length >= 3)
                    this.props.selectPlayer(2);
                else
                    this.props.selectPlayer(1);
                break;
            }
            case "up":{
                if (this.props.players.length >= 3)
                    this.props.selectPlayer(1);
                break;
            }
            case "down":{
                if (this.props.players.length >= 4)
                    this.props.selectPlayer(3);
                break;
            }
            default : {
                console.log("Undetected action");
            }
        }
    }

    render() {
        //Create player displays
        var playerDisplays = this.props.players.map((player, index) => {
            return <Text key={index} style={styles.textModal}>{player.name}</Text>;
        });

        return (
            <View>
                <Modal animationType={"fade"} onRequestClose={null} supportedOrientations={["landscape"]} transparent={true}
                    visible={this.props.showPointsModal}>
                    <View style={styles.modalBackground}>
                        <View style={styles.modalDialogLarge}>
                            <ImageBackground source={require("../../../assets/clapboard_temp.png")} style={styles.backgroundModal} imageStyle={styles.backgroundImageStretch}>
                                <View style={styles.modalDialogInner}>
                                    <SwipeGesture gestureStyle={styles.gestureStyle} onSwipePerformed={this.onSwipePerformed}>
                                        <View style={styles.viewPointsParent}>
                                            <View style={styles.viewPointsPlayer}>
                                                {playerDisplays[0]}
                                            </View>

                                            <View style={styles.viewPointsPlayerColumn}>
                                                <View style={styles.viewPointsPlayer}>
                                                    {playerDisplays.length >= 3 ? playerDisplays[1] : null}
                                                </View>
                                                
                                                <View style={styles.viewPointsPlayer}>
                                                    <Text style={styles.textModal}>Assign Points to:</Text>
                                                    {this.props.currentPlayer != null ? 
                                                        <View>
                                                            <Text style={styles.textModal}>
                                                                {this.props.players[this.props.currentPlayer].name}
                                                            </Text>
                                                            <Button onPress={this.props.assignPoints} text="Confirm" />
                                                        </View>
                                                        :
                                                        null
                                                    }
                                                </View>

                                                <View style={styles.viewPointsPlayer}>
                                                    {playerDisplays.length >= 4 ? playerDisplays[3] : null}
                                                </View>
                                            </View>

                                            <View style={styles.viewPointsPlayer}>
                                                {playerDisplays.length >= 3 ? playerDisplays[2] : playerDisplays[1]}
                                            </View>
                                        </View>
                                    </SwipeGesture>
                                </View>
                            </ImageBackground>
                        </View>
                    </View>
                </Modal>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        currentPlayer:      state.pointsPlayer,
        players:            state.players,
        showPointsModal:    state.showPointsModal
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        assignPoints: ()        => { dispatch({type: Actions.ASSIGN_POINTS}) },
        selectPlayer: (player)  => { dispatch({type: Actions.SELECT_PLAYER, player: player}) }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalPoints);